import { RequestsType } from './types'
import { RequestItemModel } from '../../requests/requestsModel'
import { SAVE_REQUESTS } from './actionTypes'

const initialState: RequestItemModel[] = []

const requests = (
	state: RequestItemModel[] = initialState,
	action: RequestsType
): Partial<RequestItemModel>[] => {
	switch (action.type) {
		case SAVE_REQUESTS: {
			return 'payload' in action ? action.payload : initialState
		}
		default:
			return state
	}
}

export default requests
